import axios from 'axios';
import Service from '@advisor/util/Service';
// eslint-disable-next-line import/no-cycle
import {generateServiceProxyOptions} from '@advisor/util/advisorUtils';

const {MS_BASE, ADMIN_TOKEN_ROUTE} = Service;

export default class OnboardingRia {
  /**
   * This will create ria and riaUser for new firm.
   * @param {riaFirm, riaUser} payload
   */
  static onboardingRia(payload) {
    const defaults = {
      baseUrl: `${MS_BASE}/${ADMIN_TOKEN_ROUTE}`,
    };
    const {baseUrl, options} = generateServiceProxyOptions(defaults, true);

    return axios.post(`${baseUrl}/v1/orchestrate/riaFirmOnboarding`, payload, options);
  }

  // GET: v1/auth/emailAvailability/{email}/ria_user/{riaId}
  static getEmailAvailability(payload) {
    return axios.get(`${MS_BASE}/${ADMIN_TOKEN_ROUTE}/v1/auth/emailAvailability/${payload.email}/ria_user`);
  }
}
